<template>
  <div class="imports-form-card">
    <span class="card-title">{{ $tc('ImportNoun',1) + ' ' + $tc('Layer',2) }}</span>
    <div class="imports-form-container">
      <div
        v-for="(field, index) in fields"
        class="card-info-item-container"
        :key="field.label"
        :style="[{ width: '100%', overflow: 'visible' }]"
      >
        <div class="card-info-item">
          <input-field
            v-if="field.inputType !== 'file'"
            :key="field.varName"
            :input-type="field.inputType"
            :value="field.value"
            :label="field.label"
            :input-disabled="field.disabled"
            :select-options-list="field.options"
            :disableBranchNodes="field.disableBranchNodes"
            :checkbox-options="field.checkboxOptions"
            :min="field.min"
            :max="field.max"
            :step="field.step"
            size="large"
            :clearable="field.clearable"
            :required="field.required"
            :inputFieldContainerStyling="{ 'padding': '0' }"
            :radio-options="field.radioOptions"
            :placeholder="field.placeholder"
            :input-style="inputStyle"
            @input="updateField($event, field)"
          />
          <InputField
            v-else
            :key="index"
            :inputStyle="{
              color: '#767676 !important',
            }"
            :inputFieldContainerStyling="uploadFileInputContainersStyle"
            :input-type="field.inputType"
            size="large"
            :file-types="acceptedFileTypes"
            :value="field.value"
            :required="field.required"
            :input-disabled="field.disabled"
            @input="updateField($event, field)"
          />
        </div>
      </div>
    </div>
    <div class="action-buttons">
      <custom-button
        :label="submittButtonLabel"
        :button-color="'var(--app-primary-base)'"
        :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave"
        :disabled="requiredFieldsFilled"
        :is-loading="loading"
        @buttonClick="submitForm"
      />
    </div>
  </div>
</template>

<script>
  import CustomButton from '@/newComponents/_Atoms/CustomButton';
  import InputField from "@/newComponents/_Atoms/InputField.vue";
  import { mapActions } from 'vuex';
  import { bus } from "@/main.js";

  export default {
    name: "ImportsForm",

    components: {
      CustomButton,
      InputField
    },

    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      layers: {
        type: Array
      },
      layerOptions: {
        type: Array
      }
    },

    data() {
      return {
        uploadFileInputContainersStyle: {
          'padding': '4px 0px',
        },
        actionButtonsStylingSave: {
          'font-size': '10px',
          'line-height': '12px',
          'height': '20px',
          'font-weight': '600',
          'border-radius': '4px',
        },

        inputStyle: {
          'border-radius': '4.1px',
          'border-color': 'rgb(219, 219, 224)'
        },

        importObj: {
          layer: null,
          type: null,
          projection: null,
          mapperTemplate: null,
          blocked: 'False',
          file: null,
          service: null,
          layers: null,
          workspace: null
        },
        externalLayerOptions: [
          {id: "fc_pathway", label:"Pathways",endpoint: "pathways", permissionName: "pathway"},
          {id: "fc_pole", label:"Poles",endpoint: "poles", permissionName: "pole"},
          {id: "fc_manhole",label:"Chambers", endpoint: "technicalpoints", permissionName: "technical_point"}
        ],
        workspaceOptions: [],
        attributeOptions: [],
        projectionOptions: [],
        externalServiceOptions: [],
        mapperTemplateOptions: []
      }
    },

    mounted() {
      this.loadProjectionOptions();
      this.loadWorkspaceOptions();
      this.loadExternalServices();
    },

    computed: {
      fields() {
        const typeField = {
          icon: "",
          label: this.$i18n.tc("Type", 1),
          value: this.importObj.type,
          varName: 'type',
          inputType: 'select',
          required: true,
          options: [
            { id: "csv", label: "CSV" },
            // { id: "geodatabase", label: "Geodatabase" },
            // { id: "geojson", label: "GeoJson" },
            // { id: "kml", label: "KML" },
            { id: "shape", label: "Shape" },
            { id: "external", label: "External" },
            // { id: "xls", label: "XLS" },
            // { id: "xlsx", label: "XLSX" }.
          ],
          placeholder: "",
          clearable: true,
          disableBranchNodes: true,
        };
        if (this.isTypeExternal) {
          return [typeField,
            {
              icon: "",
              label: this.$i18n.tc("Service", 1),
              value: this.importObj.service,
              varName: 'service',
              inputType: 'select',
              required: true,
              options: this.externalServiceOptions,
              placeholder: "",
              clearable: true,
            },
            {
              icon: "",
              label: this.$i18n.tc("Layer", 1),
              value: this.importObj.layers,
              varName: 'layers',
              inputType: 'multiselect',
              required: true,
              options: this.externalLayerOptions,
              placeholder: "",
              clearable: true,
            },
            {
              icon: "",
              label: this.$i18n.tc("Workspace", 1),
              value: this.importObj.workspace,
              varName: 'workspace',
              inputType: 'select',
              required: true,
              options: this.workspaceOptions,
              placeholder: "",
              clearable: true,
            },
          ];
        } else {
          return [
            typeField,
            {
              icon: "",
              label: this.$i18n.tc("Layer", 1),
              value: this.importObj.layer,
              varName: 'layer',
              inputType: 'select',
              required: true,
              options: this.layerOptions,
              placeholder: "",
              clearable: true,
            },
            {
              icon: "",
              label: this.$i18n.tc("Projection", 1),
              value: this.importObj.projection,
              varName: 'projection',
              inputType: 'select',
              required: true,
              options: this.projectionOptions,
              placeholder: "",
              clearable: true,
              disableBranchNodes: true,
            },
            {
              icon: "",
              label: this.$i18n.tc("Template", 1),
              value: this.importObj.mapperTemplate,
              varName: 'mapperTemplate',
              inputType: 'select',
              required: true,
              disabled: !this.importObj.layer,
              options: this.mapperTemplateOptions,
              placeholder: "",
              clearable: true,
              disableBranchNodes: true,
            },
            {
              icon: "",
              label: this.$i18n.t("Blocked"),
              value: this.importObj.blocked,
              varName: 'blocked',
              inputType: 'radio',
              radioOptions: [{ value: 'True', label: this.$i18n.t('Yes') }, { value: 'False', label: this.$i18n.t('No') }],
              required: true,
              placeholder: "",
            },
            {
              icon: "",
              value: this.importObj.file,
              varName: 'file',
              inputType: 'file',
              required: true,
              disabled: this.fileSelectionEnabled,
            }
          ];
        }
      },

      acceptedFileTypes() {
        if (this.importObj.type === "geodatabase" || this.importObj.type === "shape") {
          return [".zip"];
        } else return ["." + this.importObj.type];
      },

      /**
       * Determines if the drop file area should be enabled ot not.
       */
      fileSelectionEnabled() {
        return !(this.importObj.layer && this.importObj.type && this.importObj.projection);
      },
      isTypeExternal() {
        return this.importObj.type === "external";
      },
      requiredFieldsFilled() {
        if(this.isTypeExternal){
          return !(!!this.importObj.layers && this.importObj.type && this.importObj.service && this.importObj.workspace);
        }
        return !(this.importObj.layer && this.importObj.type && this.importObj.projection && this.importObj.file)
      },
      submittButtonLabel() {
        if(this.isTypeExternal){
          return this.$t('Sync');
        }
        return this.$t('Submit');
      }
    },

    watch: {
      'importObj.layer'(newValue){
        if(newValue){
          this.importObj.mapperTemplate = null;
          this.mapperTemplateOptions = [];
          this.loadMapperTemplateOptions();
        }
      }
    },

    methods: {
      ...mapActions([
        'FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS',
        'GET_LAYER_ATTRIBUTES',
        'GET_LIST',
        'GET_MAPPER_TEMPLATES_BY_LAYER',
        'fetchIntegrations',
        "fetchAllWorkspaces",
      ]),

      /**
       * Imports the features in the input file, adds it to the map and centers it on the feature
       */
      async submitForm() {   
        if(this.isTypeExternal){
          this.$emit('submit-external-form', {action: "get_all_data",service_uuid: this.importObj.service, layers: this.importObj.layers, workspace_uuid: this.importObj.workspace});
        } else {
          let layer = this.layers.find(layer => layer.layer === this.importObj.layer);
          let endpoint = layer.endpoint;
          let data = this.preparedDataToSend(layer);
          this.$emit('submit-form', {endpoint, data});
        }
      },

      resetForm(){
        this.importObj = {
          layer: null,
          type: null,
          layers:[],
          service: null,
          workspace:null,
          projection: null,
          mapperTemplate: null,
          blocked: 'False',
          file: null
        };
        bus.$emit("delete-all-files");
      },

      preparedDataToSend(layer) {
        let formData = new FormData();
        formData.append("file", this.importObj.file);
        formData.append("projection", this.importObj.projection);
        formData.append("file_type", this.importObj.type);
        formData.append("blocked", this.importObj.blocked);
        formData.append("template_id", this.importObj.mapperTemplate);
        if (layer.hasExtraFormDataField) {
          formData.append(layer.permissionName + "_type", layer.layer);
        }
        return formData;
      },

      updateField(event, field) {
        this.importObj[field.varName] = event;
      },

      async loadWorkspaceOptions() {
        let rawWorkspaceOptions = await this.fetchAllWorkspaces({
            includes: null,
            fields: "wp_uuid,wp_label"
          });
        let workspaceOptions = [];
        rawWorkspaceOptions.forEach(workspace => {
          workspaceOptions.push({
            id: workspace.wp_uuid,
            label: workspace.wp_label
          });
        });
        this.workspaceOptions = workspaceOptions;
      },

      async loadExternalServices() {
        this.loading = true;
        try {
          let services = await this.fetchIntegrations();
          let externalServices = services.filter(service => service.integration_type === "OpenReach");
          let externalServiceOptions = [];
          externalServices.forEach(service => {
            externalServiceOptions.push({
              id: service.uuid,
              label: service.name
            });
          });
          this.externalServiceOptions = externalServiceOptions;
        } catch (error) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      },
      /**
       * Loads list of projection options
       */
      loadProjectionOptions() {
        let projectionOptions = [];
        this.GET_LIST({ listName: "list_projections" })
          .then(projections => {
            projections.forEach(projection => {
              projectionOptions.push({
                id: projection.code,
                label: projection.code + " : " + projection.definition
              });
            });
            this.projectionOptions = projectionOptions;
          })
          .catch(error => {
            console.error(error);
          });
      },
      /**
       * Loads list of projection options
       */
      loadMapperTemplateOptions() {
        const layer = this.layers.find(layer => layer.layer === this.importObj.layer);
        let layerName = layer.layer;
        let mapperTemplateOptions = [];
        this.GET_MAPPER_TEMPLATES_BY_LAYER(layerName)
          .then(templates => {
            templates.forEach(template => {
              mapperTemplateOptions.push({
                id: template.id,
                label: template.name
              });
            });
            this.mapperTemplateOptions = mapperTemplateOptions;
          })
          .catch(error => {
            console.error(error);
          });
      },
    }
  }
</script>

<style scoped>
  .imports-form-card {
    height: 100%;
    max-height: 100%;
    background-color: #fff;
    position: relative;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
  }

  .card-title {
    color: #767676;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 800;
    line-height: 20px;
    text-transform: uppercase;
    margin-bottom: 12px;
  }

  .action-buttons {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: flex-end;
    position: absolute;
    right: 16px;
    bottom: 18px;
  }

  .imports-form-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/newComponents/Data/Imports/ImportsForm.vue